import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@app/router/routes'

// Route names in one place — the redirect and each record refer to these.
const MARKETPLACE_ROUTE_NAME = {
  LISTINGS: 'MARKETPLACE_LISTINGS',
  LISTING_DETAIL: 'MARKETPLACE_LISTING_DETAIL',
  TRADES: 'MARKETPLACE_TRADES',
  TRADES_STUCK: 'MARKETPLACE_TRADES_STUCK',
  TRADES_RECONCILIATION: 'MARKETPLACE_TRADES_RECONCILIATION',
  TRADE_DETAIL: 'MARKETPLACE_TRADE_DETAIL',
  CONTROLS: 'MARKETPLACE_CONTROLS',
  PROPERTY_TRADING: 'MARKETPLACE_PROPERTY_TRADING',
} as const

const MARKETPLACE_ROUTE_META = {
  requiresAuth: true,
  activeMenu: 'Marketplace',
} as const

export const marketplaceRoutes: RouteRecordRaw[] = [
  // Module root → the listings register, the first work queue in the sidebar.
  {
    path: routes.MARKETPLACE,
    redirect: { name: MARKETPLACE_ROUTE_NAME.LISTINGS },
  },
  {
    path: routes.MARKETPLACE_LISTINGS,
    name: MARKETPLACE_ROUTE_NAME.LISTINGS,
    component: () => import('./pages/MarketplaceListingsPage.vue'),
    meta: MARKETPLACE_ROUTE_META,
  },
  {
    path: routes.MARKETPLACE_LISTING_DETAIL,
    name: MARKETPLACE_ROUTE_NAME.LISTING_DETAIL,
    component: () => import('./pages/MarketplaceListingDetailPage.vue'),
    meta: MARKETPLACE_ROUTE_META,
  },
  // Static trade views are declared before `:id` so they never read as a trade id.
  {
    path: routes.MARKETPLACE_TRADES,
    name: MARKETPLACE_ROUTE_NAME.TRADES,
    component: () => import('./pages/MarketplaceTradesPage.vue'),
    meta: MARKETPLACE_ROUTE_META,
  },
  {
    path: routes.MARKETPLACE_TRADES_STUCK,
    name: MARKETPLACE_ROUTE_NAME.TRADES_STUCK,
    component: () => import('./pages/MarketplaceStuckTradesPage.vue'),
    meta: MARKETPLACE_ROUTE_META,
  },
  {
    path: routes.MARKETPLACE_TRADES_RECONCILIATION,
    name: MARKETPLACE_ROUTE_NAME.TRADES_RECONCILIATION,
    component: () => import('./pages/MarketplaceTradesReconciliationPage.vue'),
    meta: MARKETPLACE_ROUTE_META,
  },
  {
    path: routes.MARKETPLACE_TRADE_DETAIL,
    name: MARKETPLACE_ROUTE_NAME.TRADE_DETAIL,
    component: () => import('./pages/MarketplaceTradeDetailPage.vue'),
    meta: MARKETPLACE_ROUTE_META,
  },
  {
    path: routes.MARKETPLACE_CONTROLS,
    name: MARKETPLACE_ROUTE_NAME.CONTROLS,
    component: () => import('./pages/MarketplaceControlsPage.vue'),
    meta: MARKETPLACE_ROUTE_META,
  },
  {
    path: routes.MARKETPLACE_PROPERTY_TRADING,
    name: MARKETPLACE_ROUTE_NAME.PROPERTY_TRADING,
    component: () => import('./pages/MarketplacePropertyTradingPage.vue'),
    meta: MARKETPLACE_ROUTE_META,
  },
]
